"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = require("vue");

var _useSheetMusicBusiness = _interopRequireDefault(require("../../hooks/useSheetMusicBusiness"));

var _dataMap = require("../../utils/dataMap");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable @typescript-eslint/no-unused-vars */


var _default = function _default(props) {
  var _a;

  var sheetMusicEl = (0, _vue.ref)();
  var sheetMusicBusiness = (0, _vue.shallowRef)();
  var loadSheetResult = (0, _vue.ref)(true); // const jsBridge = window.WebViewJavascriptBridge;

  var businessOptions = _lodash.default.merge({}, {
    userOptions: {
      fontSize: 40,
      pageWidth: 1000,
      // lyricsMargin: 1.2,
      lyricFontWeight: props.platform === 'android' ? false : true,
      showAuxItem: false,
      disableAllSelect: true,
      readonly: false
    },
    playerOptions: {
      playerToolType: _dataMap.PlayerToolType.Mp3,
      playerType: 'fluidsynthjs',
      instrumentBaseUrl: 'https://music-score.ecoach.evideo.tech/',
      fluidsynthLibHost: process ? ((_a = process.env) === null || _a === void 0 ? void 0 : _a.VUE_APP_HOST) || '' : ''
    },
    pluginOptions: {
      Highlight: {
        enable: true
      },
      ErrorCorrectionRenderPlugin: {
        enable: true // init: () => {},

      },
      BeatRender: {
        enable: true,
        params: [false]
      },
      OpenAreaSelection: {
        enable: true,
        init: function init() {}
      },
      CloseAreaSelection: {
        enable: true,
        init: function init() {}
      },
      RollCallRender: {
        enable: true,
        params: [true, false]
      },
      ColvinMelodyRender: {
        enable: true,
        params: [true, false] // 开启旋律线光标,手动停止展现所有旋律线

      },
      PitchBarRender: {
        enable: true,
        init: function init() {}
      }
    }
  }, props.sheetOption || {});

  var _useSheetMusicBusines = (0, _useSheetMusicBusiness.default)(),
      sheetMusicRuntimeInit = _useSheetMusicBusines.sheetMusicRuntimeInit,
      loadSheetMusic = _useSheetMusicBusines.loadSheetMusic,
      loadSheetMusicBySvgStr = _useSheetMusicBusines.loadSheetMusicBySvgStr;

  var setBusinessOptions = function setBusinessOptions(option) {
    return new Promise(function (reslove) {
      businessOptions = _lodash.default.merge(businessOptions, option);
      reslove(businessOptions);
    });
  };

  var renderSheet = function renderSheet() {
    return sheetMusicRuntimeInit().then(function () {
      businessOptions.userOptions.scaleCase = sheetMusicEl.value.offsetWidth / 1920;
      var loadSheetFunc = props.loadSheetMode === 'common' ? loadSheetMusic : loadSheetMusicBySvgStr;
      return loadSheetFunc;
    }).then(function (loadSheetFunc) {
      var _a;

      return loadSheetFunc(sheetMusicEl.value, businessOptions, props.song.evxmlFileUrl, props.svgApi, (_a = props.song) === null || _a === void 0 ? void 0 : _a.cloudEvxmlFileUrl);
    }).then(function (_sheetMusicBusiness) {
      if (_sheetMusicBusiness) {
        sheetMusicBusiness.value = _sheetMusicBusiness;
      }
    }).then(function () {
      if (!sheetMusicBusiness.value) {
        loadSheetResult.value = false;
        return new Error('load sheet failed');
      }
    });
  };

  var destroySheet = function destroySheet() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _b, _c;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!sheetMusicBusiness.value) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.destroyPlayerTool();

            case 3:
              (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.destroyed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  return {
    sheetMusicEl: sheetMusicEl,
    sheetMusicBusiness: sheetMusicBusiness,
    loadSheetResult: loadSheetResult,
    setBusinessOptions: setBusinessOptions,
    renderSheet: renderSheet,
    destroySheet: destroySheet
  };
};

exports.default = _default;